import baseTheme from './PippoTheme';

const theme = {
  headerMaterialDark: '#000000',
  headerMaterialLight: '#000000',
  textInvert: '#bfff00',
};

export default { ...baseTheme, ...theme };
